export default {
  defaultKpiName: 'Ventas',
  linkCopied: '¡Enlace copiado al portapapeles!',
  kpi: 'KPI',
  sharePlan: 'Compartir Plan',
  share: 'Compartir',
  sharingDisabled: 'Compartir desactivado',
  sharingEnabled: 'Compartir activado',
  creatingLink: 'Creando Enlace...',
  done: 'Listo',
  budget: 'Presupuesto',
  upTo: 'hasta {value}',
  restrictions: 'Restricciones',
  spendIn: 'Gasto en',
  and: 'y',
  predictedSales: '{kpi} proyectadas',
  fullPeriodSummary: 'Resumen del Período Completo',
  monthlyDetailView: 'Vista Detallada Mensual',
  weeklyDetailView: 'Vista Detallada Semanal',
  touchpoints: 'Puntos de Contacto',
  segments: 'Segmentos',
  admin: 'Admin',
  mediaSpendCalendar: 'Calendario de Gasto en Medios',
  rawOutput: 'Salida RAW',
  injectChanges: 'Inyectar cambios',
  loading: 'Cargando...',
  unrestricted: 'Sin Restricciones',
  moreThan: 'Más de',
  lessThan: 'Menos de',
  between: 'Entre',
  exactly: 'Exactamente',
  betaOptimizerTooltip: 'Este plan usa el nuevo optimizador (beta)',
  // XLSX download
  xlsxPlan: 'Plan',
  xlsxFirstValue: 'Primer valor',
  xlsxSecondValue: 'Segundo valor',
  xlsxShareOfBudget: 'Porcentaje del presupuesto',
  xlsxTouchpoint: 'Touchpoint',
  xlsxVariability: 'Variabilidad',
  xlsxTotal: 'Total',
  spendByTouchpoint: 'Inversión por Touchpoint',
  spendBySegment: 'Inversión por Segmento',
  mediaKpiBySegment: '{kpi} de Medios por Segmento',
  microaudienceContribution: 'Contribución al KPI por Microaudiencia'
}
